import { format, parseISO, isToday as isTodayFn } from 'date-fns'

export const getTodayString = (): string => {
  return format(new Date(), 'yyyy-MM-dd')
}

export const formatDate = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date
  return format(dateObj, 'MMM d, yyyy')
}

export const formatDateTime = (date: Date): string => {
  return format(date, 'MMM d, yyyy h:mm a')
}

export const isToday = (dateString: string): boolean => {
  return isTodayFn(parseISO(dateString))
}

export const groupSnippetsByDate = <T extends { date: string }>(
  snippets: T[]
): Map<string, T[]> => {
  const grouped = new Map<string, T[]>()

  snippets.forEach((snippet) => {
    const existing = grouped.get(snippet.date) || []
    grouped.set(snippet.date, [...existing, snippet])
  })

  return grouped
}
